export function initCtaGradient() {
  const el = document.querySelectorAll('.js-cta-gradient');

  el.forEach((ctaEl) => {
    const ctaI = ctaEl.querySelector('i');
    if (!ctaI) {
      return;
    }
    ctaEl.addEventListener('mousemove', (ev) => {
      ctaI.style.left = `${ev.offsetX}px`;
      ctaI.style.top = `${ev.offsetY}px`;
    });
    ctaEl.addEventListener('mouseout', (ev) => {
      ctaI.style.left = '0';
      ctaI.style.top = '0';
    });
  });
}
